export default function Chat() {
  return <div className="animate-fade-in"><h1 className="text-3xl font-bold">Chat</h1></div>
}
